/* eslint-disable i18next/no-literal-string */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Legend } from 'recharts';

import Text from '../../shared/Typography';
import CodeBlock from './CodeBlock';

const Graphs = () => {
  const data = [
    { x: 'Jan 1, 2017', result: 17, low: 11, high: 145 },
    { x: 'May 1, 2017', result: 10, low: 11, high: 145 },
    { x: 'Apr 1, 2017', result: 22, low: 11, high: 145 },
    { x: 'Jun 1, 2017', result: 30, low: 11, high: 145 },
    { x: 'Aug 1, 2017', result: 50, low: 11, high: 145 }
  ];
  const { t } = useTranslation('graphs');

  return (
    <React.Fragment>
      <Text h2 className='pattern-library__section-title'>{t('graphs')}</Text>
      <CodeBlock>{t('info')}</CodeBlock>
      <Text h3 className='pattern-library__title'>{t('ferritin')}</Text>
      <LineChart width={800} height={300} data={data}>
        <XAxis dataKey='x' />
        <YAxis domain={['dataMin - 50', 'dataMax + 50']} />
        <CartesianGrid stroke='#eee' />
        <Legend verticalAlign='top' height={36} />
        <Line type='monotone' dataKey='result' stroke='#8884d8' animationDuration={300} />
        <Line type='monotone' dataKey='low' stroke='#82ca9d' animationDuration={300} />
        <Line type='monotone' dataKey='high' stroke='#82ca9d' animationDuration={300} />
      </LineChart>
    </React.Fragment>
  );
};

export default Graphs;



// WEBPACK FOOTER //
// ./src/components/pages/pattern-library/graphs.js